var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { GroupsMode } from "../../../Register";
import { Form, IconButton } from "@brushfire/ui";
import { useDispatch, useSelector } from "react-redux";
import FormikContextListener from "../../../../../Helpers/FormikContextListener";
import Constants from "../../../../../../data/constants";
import * as Yup from "yup";
import { handleErrors } from "../../../../../../data/helpers";
import { validateGroupPasscode } from "../../../../../../data/api";
import { setFormIsSubmitting } from "../../../../../../store/AppState/actions";
import { LOCAL_STORAGE_KEYS, setLocal } from "../../../../../../data/localStorageHelpers";
import WidgetFieldset from "../../../../../Helpers/WidgetFieldset";
import useWidgetHistory from "../../../../../../hooks/useWidgetHistory";
import useGroupData from "../../../../../../hooks/useGroupData";
var useTypedSelector = useSelector;
var GroupJoin = function (_a) {
    var _b, _c;
    var eventData = _a.eventData, path = _a.path, groupsMode = _a.groupsMode, setGroupsMode = _a.setGroupsMode;
    var groups = useTypedSelector(function (store) { return store.events; }).groups;
    var isAutoRegMode = useTypedSelector(function (store) { return store.app; }).isAutoRegMode;
    var attendeeTypeData = useTypedSelector(function (store) { return store.attendees; }).attendeeTypeData;
    var _d = __read(useState(false), 2), showGroupResults = _d[0], setShowGroupResults = _d[1];
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var groupId = useGroupData((_b = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _b !== void 0 ? _b : 0).groupId;
    var onSubmit = function (values, formikHelpers) {
        dispatch(setFormIsSubmitting(true));
        if (eventData) {
            validateGroupPasscode(__assign(__assign({}, values), { eventId: eventData.id }))
                .then(function (_a) {
                var _b;
                var data = _a.data;
                if (data) {
                    setLocal("".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat((_b = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _b !== void 0 ? _b : ""), JSON.stringify({
                        groupId: data,
                        name: values.groupName,
                    }), 60 * 30);
                    setGroupsMode(GroupsMode.hide);
                }
                else {
                    formikHelpers.setFieldError("joinCode", "Invalid Passcode");
                }
            })
                .catch(function (err) {
                var _a, _b, _c, _d;
                formikHelpers.setFieldError("joinCode", "Invalid Passcode");
                handleErrors((_d = (_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c.map(function (error) { return ({
                    key: error.key,
                    value: error.value,
                }); })) !== null && _d !== void 0 ? _d : [], formikHelpers);
            })
                .finally(function () {
                dispatch(setFormIsSubmitting(false));
                formikHelpers.setSubmitting(false);
            });
        }
    };
    useEffect(function () {
        if (!groups && groupsMode === GroupsMode.joinGroup) {
            setGroupsMode(GroupsMode.createGroup);
        }
    }, [groupsMode, groups]);
    if (!eventData || !groups) {
        return null;
    }
    var groupTypes = eventData.isGroupCentric
        ? attendeeTypeData !== null && attendeeTypeData !== void 0 ? attendeeTypeData : []
        : (_c = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.filter(function (a) { return a.isGroup; })) !== null && _c !== void 0 ? _c : [];
    var JoinSchema = Yup.object().shape({
        groupName: Yup.string().required("Group is required"),
        joinCode: Yup.string().required("Passcode is required"),
    });
    return (_jsx(_Fragment, { children: _jsx(Form, __assign({ initialValues: {}, onSubmit: onSubmit, validationSchema: JoinSchema, useUnsavedPrompt: false }, { children: function (_a) {
                var formikContext = _a.formikContext;
                return (_jsxs(_Fragment, { children: [_jsx(FormikContextListener, { currentPath: path, path: [
                                Constants.Routes.register,
                                Constants.Routes.tickets,
                                Constants.Routes.autoreg,
                                Constants.Routes.calendar,
                                Constants.Routes.section,
                            ], formikContext: formikContext, active: groupsMode === GroupsMode.joinGroup }), _jsxs(WidgetFieldset, { children: [_jsxs("div", __assign({ className: "d-flex align-items-center justify-content-between" }, { children: [_jsx("h4", __assign({ className: "semi-bold mb-0" }, { children: "Join A Group" })), _jsx(IconButton, { ariaLabel: "Back to Group Choices", icon: "times", classes: "d-inline-flex m-left p-top-icon-3", onClick: function (evt) {
                                                evt.stopPropagation();
                                                evt.preventDefault();
                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                //@ts-ignore
                                                formikContext.resetForm({ values: {} });
                                                if (!eventData.isGroupCentric || groupId) {
                                                    setGroupsMode(GroupsMode.hide);
                                                }
                                                else {
                                                    setGroupsMode(GroupsMode.buttons);
                                                }
                                            } })] })), _jsx("p", __assign({ className: "p-top" }, { children: "Please note that by joining a group you are granting permission to the group manager to access your registration details and make changes on your behalf. If you do not wish to provide the group manager with access to your registration details, please do not join a group." })), groupTypes.length > 0 && (_jsx("p", { children: _jsx("a", __assign({ href: "#", onClick: function (evt) {
                                            evt.preventDefault();
                                            evt.stopPropagation();
                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                            //@ts-ignore
                                            formikContext.resetForm({ values: {} });
                                            setGroupsMode(GroupsMode.createGroup);
                                        }, className: "btn btn-sm btn-secondary unstyled-link" }, { children: "Create a group instead" })) })), _jsx(Form.Field, { label: "Search for an existing group", component: Form.Input.Select, id: "groupName", name: "groupName", data: groups.map(function (group) { return ({
                                        label: group,
                                        value: group,
                                    }); }), autoComplete: "off", loadOptionsAsync: eventData.isGroupPrivate
                                        ? function (input, callback) {
                                            var results = [];
                                            if (input.length > 4) {
                                                if (!showGroupResults) {
                                                    setShowGroupResults(true);
                                                }
                                                groups.forEach(function (group) {
                                                    if (group.toLowerCase().includes(input.toLowerCase())) {
                                                        results.push({
                                                            label: group,
                                                            value: group,
                                                        });
                                                    }
                                                });
                                            }
                                            else if (showGroupResults) {
                                                setShowGroupResults(false);
                                            }
                                            callback(results);
                                        }
                                        : undefined, noOptionsMessage: eventData.isGroupPrivate
                                        ? function (input) {
                                            if (input.length > 4) {
                                                return "No Groups Found";
                                            }
                                            else {
                                                return "Type to search...";
                                            }
                                        }
                                        : undefined }), _jsx(Form.Field, { label: "Passcode to join this group", id: "joinCode", name: "joinCode", autoComplete: "new-off" }), path !== Constants.Routes.calendar && (_jsxs(_Fragment, { children: [_jsx("p", { children: "Don't know the passcode to join your group? Contact your group's manager." }), _jsxs("p", { children: ["Are you the manager and you forgot your passcodes?", " ", _jsx("a", __assign({ href: Constants.Routes.resetGroup
                                                        .replace(":clientKey", eventData.clientKey)
                                                        .replace(":urlKey", eventData.urlKey)
                                                        .replace(":eventNumber", eventData.eventNumber.toString()), onClick: function (evt) {
                                                        evt.preventDefault();
                                                        history.push(Constants.Routes.resetGroup
                                                            .replace(":clientKey", eventData.clientKey)
                                                            .replace(":urlKey", eventData.urlKey)
                                                            .replace(":eventNumber", eventData.eventNumber.toString()));
                                                    }, className: "pointer" }, { children: "Click here" })), "."] })] }))] })] }));
            } })) }));
};
export default GroupJoin;
